<template>
    <rkm-overlay>
        <rkm-layout-body title="Fila">
            <template
                v-if="showAlterarStatusParaEmEsperaButton && additionals && additionals.isSupervisor && additionals.hasStatusEmEspera"
                v-slot:actions
            >
                <rkm-button
                    @click="$refs.List.updateSolicitacoes()"
                    color="info"
                >
                    Alterar o status de todos os pacientes listados para Em espera
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/regulacao/fila/List'

export default {
    components: { List },
}
</script>